import { ThemeEvents } from "@theme/events";

let currentSort = "random";

function getGrid() {
  return document.querySelector("[data-dtails-team-collection] .product-grid");
}

function getComparableValue(card, sort) {
  if (sort.startsWith("joined")) return card.dataset.dtailsJoined || null;

  if (sort.startsWith("height")) {
    const height = Number.parseFloat(card.dataset.dtailsHeight || "");
    return Number.isFinite(height) ? height : null;
  }

  return null;
}

function shuffle(cards) {
  for (let index = cards.length - 1; index > 0; index -= 1) {
    const randomIndex = Math.floor(Math.random() * (index + 1));
    [cards[index], cards[randomIndex]] = [cards[randomIndex], cards[index]];
  }
}

function sortCards(cards, sort) {
  if (sort === "random") {
    shuffle(cards);
    return;
  }

  const direction = sort.endsWith("-asc") ? 1 : -1;

  cards.sort((cardA, cardB) => {
    const valueA = getComparableValue(cardA, sort);
    const valueB = getComparableValue(cardB, sort);

    // Employees without the selected value always stay at the end.
    if (valueA === null && valueB === null) return 0;
    if (valueA === null) return 1;
    if (valueB === null) return -1;

    if (valueA < valueB) return -1 * direction;
    if (valueA > valueB) return 1 * direction;
    return 0;
  });
}

function syncControls(sort) {
  document.querySelectorAll("[data-dtails-team-sort]").forEach((control) => {
    if (control instanceof HTMLSelectElement) control.value = sort;
    if (control instanceof HTMLInputElement) control.checked = control.value === sort;
  });
}

function applySort(sort = currentSort) {
  const grid = getGrid();
  if (!grid) return;

  const cards = Array.from(grid.children).filter((card) => card.matches("[data-product-id]"));
  if (cards.length < 2) return;

  currentSort = sort;
  sortCards(cards, sort);

  const fragment = document.createDocumentFragment();
  cards.forEach((card) => fragment.append(card));
  grid.append(fragment);
  syncControls(sort);
}

function onSortChange(event) {
  const control = event.target.closest?.("[data-dtails-team-sort]");
  if (!control) return;

  event.preventDefault();
  event.stopImmediatePropagation();
  applySort(control.value);
}

function initialize() {
  if (!document.querySelector("[data-dtails-team-collection]")) return;

  document.addEventListener("change", onSortChange, true);
  document.addEventListener(ThemeEvents.collectionRerendered, () => applySort(currentSort));
  document.addEventListener("shopify:section:load", () => applySort(currentSort));
  applySort("random");
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initialize, { once: true });
} else {
  initialize();
}
